var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cv-content-switcher-button",class:[
    `${_vm.carbonPrefix}--content-switcher-btn`,
    {
      [`${_vm.carbonPrefix}--content-switcher--selected`]: _vm.dataSelected,
    },
  ],attrs:{"type":"button","role":"tab","data-target":_vm.contentSelector,"aria-selected":_vm.dataSelected ? 'true' : 'false',"id":_vm.uid},on:{"click":_vm.open}},[(_vm.icon)?_c('CvSvg',{class:`${_vm.carbonPrefix}--content-switcher__icon`,attrs:{"svg":_vm.icon,"height":"16","width":"16"}}):_vm._e(),_c('span',{class:`${_vm.carbonPrefix}--content-switcher__label`},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }